import { useQuery } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";

interface GetStudentsParams {
  search?: string;
  isDeleted?: boolean;
  isEmailVerified?: boolean;
  isAccountVerified?: boolean;
  page: number;
}

export const useGetStudentsonAdminQuery = ({
  search,
  isDeleted,
  isEmailVerified,
  isAccountVerified,
  page,
}: GetStudentsParams) => {
  const token = localStorage.getItem("W2ST_ADMIN_TOKEN");

  return useQuery({
    queryKey: [
      "useGetStudentsonAdminQuery",
      { search, isDeleted, isEmailVerified, isAccountVerified, page },
    ],
    queryFn: async () => {
      if (!token) throw new Error("Authorization token is missing");

      const params = {
        ...(search && { search }),
        ...(isDeleted && { isDeleted }),
        ...(isEmailVerified && { isEmailVerified }),
        ...(isAccountVerified && { isAccountVerified }),
        page,
      };

      const response = await axiosInstance.get("admins/students", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      });

      return response.data;
    },
    onSuccess: (data) => {
      console.log("Success Getting Tutors ==>", data);
    },
    onError: (error: unknown) => {
      console.error("Failed Getting Tutors ==>", error);
    },
    enabled: !!token,
  });
};
